<template>
    <div class="store-table">
        <el-table
            max-height="495"
            :data="newTableData"
            style="width: 100%"
            v-loading="loading"
        >
            <!-- <el-table-column prop="id" label="招标项目编码"> </el-table-column>
            <el-table-column prop="name" label="招标项目名称">
            </el-table-column> -->
            <el-table-column
                v-for="col in config.columns"
                :prop="col.prop"
                :label="col.label"
                :key="col.prop"
                :width="col.width"
                show-overflow-tooltip
            >
                <template slot-scope="{ row }">
                    <span v-if="col.colorPoints && col.colorPoints" class="color-point" :style="{ backgroundColor: filterColor(row[col.prop], col.colorPoints) }"></span>
                    <span v-if="col.type === 'select'">{{ col.prop + '_' in row ? row[col.prop + '_'] : row[col.prop] }}</span>
                    <span v-else>{{ row[col.prop] }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="config.action && config.action.length"
                label="操作"
                :fixed="config.actionFixed || 'right'"
                :width="config.actionWidth || 100"
            >
                <template slot-scope="{ row }">
                    <el-button
                        v-for="item in config.action"
                        :key="item.event"
                        type="text"
                        @click="handleEventClick(row, item.event)"
                        >{{ item.label }}</el-button
                    >
                </template>
            </el-table-column>

            <div slot="empty">
                <img class="img" src="./img/table-empty.png" alt="" />
                <div class="empty-text">暂无数据</div>
            </div>
        </el-table>
        <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
    </div>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api';
// import { supplierNoticeHomePage } from "../manageDesk/manageDaskApi";
// import { mapGetters } from "vuex";
export default {
    props: {
        config: {
            type: Object,
            default: () => ({
                columns: [],
            })
        },
        tableData: {
            type: Array,
            default: () => []
        },
        currentPage: {
            type: Number,
            default: () => 1
        },
        total: {
            type: Number,
            default: () => 0
        },
        loading: {
            type: Boolean,
            default: () => false
        },
    },
    data() {
        return {
            // tableData: [],
            dict: {},
            pageSize: 10,
            // pageNo: 1,
            // total: 0,
            // loading: false
        };
    },
    computed: {
        // ...mapGetters(["supplier"])
        newTableData() {
            return this.tableData.map(item => {
                const newItem = { ...item };
                this.config.columns.forEach(column => {
                    if (column.type === 'select' && column.optionNum && this.dict[column.optionNum]) {
                        newItem[column.prop + '_'] = this.dict[column.optionNum][item[column.prop]]
                    }
                });
                return newItem;
            });
        },
    },
    methods: {
        // viewPage(query) {
        //     this.$router.push({
        //         path: "/lsrm/myBidding",
        //         query
        //     });
        // },
        handleSizeChange(v) {
            this.pageSize = v;
            // this.pageNo = 1;
            // this.getList();
            this.$emit('size-change', v)
        },
        handleCurrentChange(v) {
            // this.pageNo = v;
            // this.getList();
            this.$emit('current-change', v)
        },
        // getList() {
        //     const pramas = {
        //         pageNo: this.pageNo,
        //         pageSize: this.pageSize,
        //         supplierCode: this.supplier.supplierCode
        //     };
        //     this.loading = true;
        //     supplierNoticeHomePage(pramas)
        //         .then(res => {
        //             if (res && +res.code === 0) {
        //                 const { list, totalCount } = res.data;
        //                 this.total = totalCount || 0;
        //                 this.tableData = list;
        //             }
        //         })
        //         .finally(() => {
        //             this.loading = false;
        //         });
        // }
        filterColor(value, colorPoints) {
            const colorPoint = colorPoints.find(item => item.value === value);
            return colorPoint ? colorPoint.color : '';
        },
        handleEventClick(row, event) {
            this.$emit(event + '-btn', row);
        },
    },
    // watch: {
    //     tableData(val) {
    //         this.pageNo = 1;
    //         // this.getList();
    //     },
    // },
    mounted() {
        // this.getList();
        const dictCodes = this.config.columns
            .filter(item => item.type === 'select' && item.optionNum)
            .map(item => item.optionNum).join(',');
        if (dictCodes) {
            dictWithUrl(dictCodes).then(res => {
                if (res && +res.code === 0) {
                    this.dict = res.data;
                }
            });
        }
    },
    // filters: {
    //     dictFilter(val, dictCode) {
    //         const dict = this.dict[dictCode];
    //         if (dict) {
    //             const item = dict.find(item => item.dictValue === val);
    //             return item ? item.dictName : val;
    //         }
    //         return val;
    //     }
    // },
};
</script>
<style lang="less" scoped>
.store-table {
    /deep/ .el-table {
        .cell {
            line-height: 34px;
        }
        th {
            background-color: #f2f3f5;
        }
        .el-table__empty-block {
            min-height: 170px;
            font-size: 14px;
            color: #4e5969;
            .img {
                width: 110px;
                height: 80px;
                display: block;
                margin: 0 auto;
            }
            .empty-text {
                line-height: 22px;
                margin-top: 8px;
                color: #4E5969;
            }
        }
    }
    .pagination {
        text-align: right;
        margin-top: 16px;
    }

    .color-point {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        margin-right: 8px;
    }
}
</style>
